import api from "services/api";

export const fetchTotalConsommation = async () => {
  try {
    const response = await api.get(
      "/api/consommations/total"
    );

    return response.data.totalConsommation;
  } catch (error) {
    console.error(
      "Error fetching total consommation:",
      error
    );

    throw error;
  }
};

export const fetchSummedDonnees = async (
  startDate,
  endDate
) => {
  try {
    const response = await api.get(
      "/api/donnees/summed",
      {
        params: { startDate, endDate },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching summed donnees:",
      error
    );

    throw error;
  }
};